import React from "react";
import PropTypes from "prop-types";
import Limiter from "../../../../components/atoms/Limiter";
import ExpandLink from "../../../../components/atoms/Limiter/ExpandLink";
import TableSorter from "../../../../components/atoms/TableSorter";
import GenCCTable from "./GenCCTable";
import { sortStr } from "../../../../common/helpers/helpers";

const sortByDisease = (a, b) => sortStr(a.disease, b.disease);
const renderTable = (props) => {
  return <GenCCTable {...props} />;
};

const renderLimiter = (props) => {
  return (
    <React.Fragment>
      <Limiter
        {...props}
        ExpandLink={(p) => (
          <div className="tw-p-2">
            <ExpandLink {...p} />
          </div>
        )}
        items={props.sortedItems}
        limit={5}
        shouldAutoCollapse={false}
        renderContent={renderTable}
      />
    </React.Fragment>
  );
};

function GenCCContent(props) {
  const { items } = props;

  return (
    <div id="gencc">
      <TableSorter
        {...props}
        items={items}
        defaultSortedField="disease"
        defaultComparator={sortByDisease}
        renderContent={renderLimiter}
      />
    </div>
  );
}

GenCCContent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      disease: PropTypes.string,
      verdict: PropTypes.string,
      expert_panel: PropTypes.string,
    })
  ),
};

GenCCContent.defaultProps = {
  items: [],
};

export default GenCCContent;
